import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { Brand } from "../brand/Brand";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { shallowEqual, useSelector } from "react-redux";

// export const menuList = [
//   { id: 1, isTabMenu: true, tabId: 0, title: "ASID.TABS.BASEINFO", url: '/baseInfo', hasSubMenu: false, parentMenuId: 0, iconUrl: '/media/svg/icons/Code/Settings4.svg' },
//   { id: 2, isTabMenu: true, tabId: 0, title: "ASID.TABS.CULLINAN", url: '/cullinan', hasSubMenu: false, parentMenuId: 0, iconUrl: '/media/svg/icons/Cooking/Chef.svg' },
//   { id: 3, isTabMenu: true, tabId: 0, title: "ASID.TABS.DORMITORY", url: '/dormitory', hasSubMenu: false, parentMenuId: 0, iconUrl: '/media/svg/icons/Home/Bed.svg' },
//   { id: 4, isTabMenu: true, tabId: 0, title: "ASID.TABS.AUDIT.BUILDING", url: '/attendance', hasSubMenu: false, parentMenuId: 0, iconUrl: '/media/svg/icons/Communication/Group.svg' },
//   { id: 5, isTabMenu: true, tabId: 0, title: "ASID.TABS.SPORT", url: '/sport', hasSubMenu: false, parentMenuId: 0, iconUrl: '/media/svg/icons/Clothes/T-Shirt.svg' },

//   { id: 6, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.DASHBOARD", url: '/dashboard', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Design/Layers.svg' },
//   { id: 7, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.SETTING", url: '', hasSubMenu: false, parentMenuId: 1, iconUrl: '' },
//   // { id: 6, isTabMenu: false, tabId: 1, title: "راهبری عمومی", url: '\UniInfo', hasSubMenu: false, parentMenuId: 0, iconUrl: '/media/svg/icons/Code/Settings4.svg' },
//   { id: 8, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.UNIINFO", url:'/uni', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Home/Towel.svg' },
//   { id: 9, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.PROVINCE", url: '/terms', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Code/Time-schedule.svg' },
//   { id: 10, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.PLACES", url: '/grades', hasSubMenu: false, parentMenuId:1, iconUrl: '/media/svg/icons/Code/Puzzle.svg' },
//   { id: 11, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.AUDIT.MANAGMENT", url: '/collages', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Home/Home.svg' },
//   { id: 12, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.GROUPS", url: '/groups', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Communication/Group.svg' },
//   { id: 13, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.AUDIT.FORMS", url: '/dorms', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Home/Home.svg' },
//   { id: 14, isTabMenu: false,isFullAccess: false, tabId: 1, title: "ASID.TABS.AUDIT.REPORTS", url: '/accounts', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Communication/Group.svg' },
//   { id: 15, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.SHIFTS", url: '/shifts', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Communication/Group.svg' },
//   { id: 16, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.AUDIT.PERIODS", url: '/calendar', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Communication/Group.svg' },
//   { id: 17, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.AUDIT.PROFILE", url: '/devices', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Communication/Group.svg' },
//   { id: 18, isTabMenu: false,isFullAccess: true, tabId: 1, title: "ASID.TABS.BASEINFO.USERS", url: '/persons', hasSubMenu: false, parentMenuId: 1, iconUrl: '/media/svg/icons/Communication/Group.svg' },

// ];

export function Aside() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      disableScroll:
        objectPath.get(uiService.config, "aside.menu.dropdown") === "true" ||
        false,
      asideClassesFromConfig: uiService.getClasses("aside", true),
      disableAsideSelfDisplay:
        objectPath.get(uiService.config, "aside.self.display") === false,
      headerLogo: uiService.getLogo(),
    };
  }, [uiService]);

  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        className={`aside aside-left  ${layoutProps.asideClassesFromConfig} d-flex flex-column flex-row-auto`}
      >
        <Brand />

        {/* begin::Aside Menu */}
        <div
          id="kt_aside_menu_wrapper"
          className="aside-menu-wrapper flex-column-fluid"
        >
          {layoutProps.disableAsideSelfDisplay && (
            <>
              {/* begin::Header Logo */}
              <div className="header-logo">
                <Link to="">
                  <img alt="logo" src={layoutProps.headerLogo} />
                </Link>
              </div>
              {/* end::Header Logo */}
            </>
          )}
          <AsideMenu
            menuList={menuList
              .filter((q) => !q.isTabMenu && q.tabId === 1)
              .sort()
              .sort((a, b) => a.orderInTab - b.orderInTab)}
            disableScroll={layoutProps.disableScroll}
          />
        </div>
        {/* end::Aside Menu */}
      </div>
      {/* end::Aside */}
    </>
  );
}
